import React, { useContext } from 'react';
import { Row, Col, CardBody, Card, Container  } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { faFileAlt, faUpload, faCalendarAlt, faUser, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import DashboardCards from 'components/common/DashboardCards';
import AssistantWelcomeCard from 'components/assistant/AssistantWelcomeCard';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import Skeleton from 'react-loading-skeleton';

const welcomeMsg = 'speicherfuchs.welcomeMessage';

const cards = [
    {
        title: 'speicherfuchs.dashboardCards.yourData.title',
        text: 'speicherfuchs.dashboardCards.yourData.text',
        icon: faUser,
        role: 'Kunde',
        link: '/admin/profile'
    },
    {
        title: 'speicherfuchs.dashboardCards.yourCustomers.title',
        text: 'speicherfuchs.dashboardCards.yourCustomers.text',
        icon: faAddressBook,
        role: 'Helfer',
        link: '/admin/customers'
    },
    {
        title: 'speicherfuchs.dashboardCards.yourCustomers.title',
        text: 'speicherfuchs.dashboardCards.yourCustomers.text',
        icon: faAddressBook,
        role: 'Administrator',
        link: '/admin/customers'
    },
    {
        title: 'speicherfuchs.dashboardCards.uploadDocuments.title',
        text: 'speicherfuchs.dashboardCards.uploadDocuments.text',
        icon: faUpload,
        link: '/admin/documents/'
    },
    {
        title: 'speicherfuchs.dashboardCards.submitApplication.title',
        text: 'speicherfuchs.dashboardCards.submitApplication.text',
        icon: faFileAlt,
        disabled: true
    },
    {
        title: 'speicherfuchs.dashboardCards.appointments.title',
        text: 'speicherfuchs.dashboardCards.appointments.text',
        icon: faCalendarAlt,
        disabled: true
    }
  ];

function Speicherfuchs() {
    const { t } = useTranslation();

    const { userId } = useContext(UserSettingsContext);
    if(!userId){
        return <Card><CardBody><Skeleton height={40} count={5} /></CardBody></Card>
    }

    return (
        <Card className="card-tasks" style={{ height: "auto", marginLeft: "10px", borderRadius: '0.875rem', overflow: 'hidden' }}>
            <CardBody>
                <h3 className="title">{t('speicherfuchs.title')}</h3>
                <Row className="align-items-center">
                    {/*<Col xs="12" xl="6" className="order-1 order-xl-2">
                        <AssistantWelcomeCard welcomeMsg={welcomeMsg} />
                    </Col>*/}
                    <Col lg="12" xl="6" className="order-2 order-xl-1">
                        <Container className="my-4">
                            <DashboardCards cards={cards.filter(card => (card.role || userId.tenant_role) === userId.tenant_role)} />
                        </Container>        
                    </Col>
                </Row>  
                
            </CardBody>
        </Card>
    )
}

export default Speicherfuchs;